import React, { useState } from 'react';
import { styled } from '@mui/material/styles';
import {
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Collapse,
} from '@mui/material/';
import {
  StyledTableCell,
  BackButton,
  NextButton,
} from 'components/Common/MUIStyledComponents';
import Modal from 'react-modal';
import { KeyboardArrowDown, KeyboardArrowRight } from '@mui/icons-material';
import { Field } from 'formik';
import { countryCodes } from 'utils/countryCodes';

// CUSTOM TABLE ROWS
const Row = styled(TableRow)({
  root: {
    '& > *': {
      borderBottom: 'unset',
    },
  },
});

const CustomRow = (props: { row: any; handleRemove: any; edit: boolean }) => {
  const { row, handleRemove, edit } = props;
  const [open, setOpen] = useState(false);

  return (
    <React.Fragment>
      <Row>
        <StyledTableCell style={{ width: '1%' }}>
          <IconButton
            style={{ color: 'var(--alternative-text-color)' }}
            aria-label='expand row'
            size='small'
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowRight /> : <KeyboardArrowDown />}
          </IconButton>
        </StyledTableCell>
        <StyledTableCell component='th' scope='row'>
          {edit ? (
            <div
              className='name-delete-spacer cursor-pointer'
              onClick={() => {
                handleRemove(row.commodityName);
              }}
            >
              {row.commodityName}
              <svg
                xmlns='http://www.w3.org/2000/svg'
                width='24'
                height='24'
                viewBox='0 0 24 24'
                fill='none'
              >
                <path
                  d='M10 18C10.2652 18 10.5196 17.8946 10.7071 17.7071C10.8946 17.5196 11 17.2652 11 17V11C11 10.7348 10.8946 10.4804 10.7071 10.2929C10.5196 10.1054 10.2652 10 10 10C9.73478 10 9.48043 10.1054 9.29289 10.2929C9.10536 10.4804 9 10.7348 9 11V17C9 17.2652 9.10536 17.5196 9.29289 17.7071C9.48043 17.8946 9.73478 18 10 18ZM20 6H16V5C16 4.20435 15.6839 3.44129 15.1213 2.87868C14.5587 2.31607 13.7956 2 13 2H11C10.2044 2 9.44129 2.31607 8.87868 2.87868C8.31607 3.44129 8 4.20435 8 5V6H4C3.73478 6 3.48043 6.10536 3.29289 6.29289C3.10536 6.48043 3 6.73478 3 7C3 7.26522 3.10536 7.51957 3.29289 7.70711C3.48043 7.89464 3.73478 8 4 8H5V19C5 19.7956 5.31607 20.5587 5.87868 21.1213C6.44129 21.6839 7.20435 22 8 22H16C16.7956 22 17.5587 21.6839 18.1213 21.1213C18.6839 20.5587 19 19.7956 19 19V8H20C20.2652 8 20.5196 7.89464 20.7071 7.70711C20.8946 7.51957 21 7.26522 21 7C21 6.73478 20.8946 6.48043 20.7071 6.29289C20.5196 6.10536 20.2652 6 20 6ZM10 5C10 4.73478 10.1054 4.48043 10.2929 4.29289C10.4804 4.10536 10.7348 4 11 4H13C13.2652 4 13.5196 4.10536 13.7071 4.29289C13.8946 4.48043 14 4.73478 14 5V6H10V5ZM17 19C17 19.2652 16.8946 19.5196 16.7071 19.7071C16.5196 19.8946 16.2652 20 16 20H8C7.73478 20 7.48043 19.8946 7.29289 19.7071C7.10536 19.5196 7 19.2652 7 19V8H17V19ZM14 18C14.2652 18 14.5196 17.8946 14.7071 17.7071C14.8946 17.5196 15 17.2652 15 17V11C15 10.7348 14.8946 10.4804 14.7071 10.2929C14.5196 10.1054 14.2652 10 14 10C13.7348 10 13.4804 10.1054 13.2929 10.2929C13.1054 10.4804 13 10.7348 13 11V17C13 17.2652 13.1054 17.5196 13.2929 17.7071C13.4804 17.8946 13.7348 18 14 18Z'
                  fill='var(--alternative-text-color)'
                />
              </svg>
            </div>
          ) : (
            <div className='name-delete-spacer cursor-pointer'>
              {row.commodityName}
            </div>
          )}
        </StyledTableCell>
      </Row>
      <TableRow>
        <StyledTableCell
          style={{
            paddingBottom: 0,
            paddingTop: 0,
            background: '#4A4C51',
            height: '0px',
          }}
          colSpan={6}
        >
          <Collapse in={open} timeout='auto' unmountOnExit>
            <div className='doc-display-bulk'>
              <p>Commodity Name</p>
              <p>{row.commodityName ? row.commodityName : '-'}</p>
            </div>
            <div className='doc-display-bulk'>
              <p>HS Code</p>
              <p>
                {row.harmonizedScheduleCode ? row.harmonizedScheduleCode : '-'}
              </p>
            </div>
            <div className='doc-display-bulk'>
              <p>Country of Origin</p>
              <p>{row.countryOfOrigin ? row.countryOfOrigin : '-'}</p>
            </div>
            <div className='doc-display-bulk'>
              <p>Trans Shipment Country</p>
              <p>{row.transhipmentCountry ? row.transhipmentCountry : '-'}</p>
            </div>
            <div className='doc-display-bulk'>
              <p>Destination Country</p>
              <p>{row.destinationCountry ? row.destinationCountry : '-'}</p>
            </div>
          </Collapse>
        </StyledTableCell>
      </TableRow>
    </React.Fragment>
  );
};

const PREFIX = 'CommodityTable';
const classes = {
  root: `${PREFIX}-root`,
  paper: `${PREFIX}-paper`,
  visuallyHidden: `${PREFIX}-visually-hidden`,
};

const Root = styled('div')(() => ({
  [`&.${classes.root}`]: {
    width: '100%',
  },
  [`& .${classes.paper}`]: {
    width: '100%',
    marginBottom: '10px',
    background: 'var(--bg-secondary)',
  },
  [`& .${classes.visuallyHidden}`]: {
    border: 0,
    clip: 'rect(0 0 0 0)',
    height: 1,
    margin: -1,
    overflow: 'hidden',
    padding: 0,
    position: 'absolute',
    top: 20,
    width: 1,
  },
}));

interface ICommodityProps {
  commodities: any;
  setFieldValue: any;
  edit: boolean;
}

const CommodityForm: React.FC<ICommodityProps> = (props: ICommodityProps) => {
  const { commodities, setFieldValue, edit } = props;

  const [addModal, setAddModal] = useState(false);
  const [name, setName] = useState('');
  const [code, setCode] = useState('');
  const [origin, setOrigin] = useState('');
  const [trans, setTrans] = useState('');
  const [dest, setDest] = useState('');

  const handleModalOpen = () => {
    setAddModal(true);
  };

  const handleModalClose = () => {
    setAddModal(false);
  };

  const handleRemove = (nameVal: string) => {
    const arr = commodities.filter((com: any) => com.commodityName !== nameVal);
    setFieldValue('commodities', arr);
  };

  const handleAddCommodity = () => {
    const commodity = {
      commodityName: name,
      harmonizedScheduleCode: code,
      countryOfOrigin: origin,
      transhipmentCountry: trans,
      destinationCountry: dest,
    };
    let arr = [];
    if (commodities) {
      arr = commodities;
      arr.push(commodity);
    } else {
      arr = [commodity];
    }
    setFieldValue('commodities', arr);
  };

  return (
    <div className='vault-commodity-form-container'>
      <div className='vault-commodity-form-header'>
        <h3>Commodities</h3>
        <h4>View HS Codes</h4>
      </div>
      <div className='vault-commodity-form-table'>
        <Root className={classes.root}>
          <Paper className={classes.paper}>
            <TableContainer>
              <Table aria-labelledby='tableTitle' aria-label='enhanced table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell style={{ width: '1%' }}></StyledTableCell>
                    <StyledTableCell align='left' padding='normal'>
                      Commodity
                    </StyledTableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {commodities?.map((row: any) => {
                    return (
                      <CustomRow
                        key={row.name}
                        row={row}
                        handleRemove={handleRemove}
                        edit={edit}
                      />
                    );
                  })}
                </TableBody>
              </Table>
            </TableContainer>
          </Paper>
        </Root>
      </div>
      <div className='vault-commodity-form-btn'>
        {edit ? (
          <BackButton onClick={handleModalOpen}>
            Add Entry
            <div className='vault-commodity-form-btn-spacer'></div>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='18'
              height='18'
              viewBox='0 0 18 18'
              fill='none'
            >
              <path
                d='M9 3.9375V14.0625'
                stroke='var(--alternative-text-color)'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
              <path
                d='M14.0625 9H3.9375'
                stroke='var(--alternative-text-color)'
                strokeWidth='1.5'
                strokeLinecap='round'
                strokeLinejoin='round'
              />
            </svg>
          </BackButton>
        ) : (
          <></>
        )}
      </div>
      <Modal
        isOpen={addModal}
        onRequestClose={handleModalClose}
        ariaHideApp={false}
      >
        <div className='vault-commodities-modal-container'>
          <div className='vault-commodities-modal-header'>
            <h3>Add Entry</h3>
            <svg
              xmlns='http://www.w3.org/2000/svg'
              width='24'
              height='24'
              viewBox='0 0 24 24'
              fill='none'
            >
              <path
                d='M15.7098 8.29179C15.6169 8.19806 15.5063 8.12367 15.3844 8.0729C15.2626 8.02213 15.1318 7.99599 14.9998 7.99599C14.8678 7.99599 14.7371 8.02213 14.6153 8.0729C14.4934 8.12367 14.3828 8.19806 14.2898 8.29179L11.9998 10.5918L9.70984 8.29179C9.52153 8.10348 9.26614 7.9977 8.99984 7.9977C8.73353 7.9977 8.47814 8.10348 8.28983 8.29179C8.10153 8.48009 7.99574 8.73549 7.99574 9.00179C7.99574 9.26809 8.10153 9.52348 8.28983 9.71179L10.5898 12.0018L8.28983 14.2918C8.19611 14.3848 8.12171 14.4954 8.07094 14.6172C8.02017 14.7391 7.99404 14.8698 7.99404 15.0018C7.99404 15.1338 8.02017 15.2645 8.07094 15.3864C8.12171 15.5082 8.19611 15.6188 8.28983 15.7118C8.3828 15.8055 8.4934 15.8799 8.61526 15.9307C8.73712 15.9814 8.86782 16.0076 8.99984 16.0076C9.13185 16.0076 9.26255 15.9814 9.38441 15.9307C9.50627 15.8799 9.61687 15.8055 9.70984 15.7118L11.9998 13.4118L14.2898 15.7118C14.3828 15.8055 14.4934 15.8799 14.6153 15.9307C14.7371 15.9814 14.8678 16.0076 14.9998 16.0076C15.1318 16.0076 15.2626 15.9814 15.3844 15.9307C15.5063 15.8799 15.6169 15.8055 15.7098 15.7118C15.8036 15.6188 15.878 15.5082 15.9287 15.3864C15.9795 15.2645 16.0056 15.1338 16.0056 15.0018C16.0056 14.8698 15.9795 14.7391 15.9287 14.6172C15.878 14.4954 15.8036 14.3848 15.7098 14.2918L13.4098 12.0018L15.7098 9.71179C15.8036 9.61882 15.878 9.50822 15.9287 9.38636C15.9795 9.26451 16.0056 9.1338 16.0056 9.00179C16.0056 8.86978 15.9795 8.73907 15.9287 8.61721C15.878 8.49535 15.8036 8.38475 15.7098 8.29179ZM19.0698 4.93179C18.1474 3.97669 17.0439 3.21486 15.8239 2.69077C14.6038 2.16668 13.2916 1.89082 11.9638 1.87928C10.6361 1.86775 9.31926 2.12076 8.09029 2.62357C6.86133 3.12638 5.74481 3.86891 4.80589 4.80784C3.86696 5.74677 3.12443 6.86328 2.62162 8.09225C2.11881 9.32121 1.86579 10.638 1.87733 11.9658C1.88887 13.2936 2.16473 14.6058 2.68882 15.8258C3.21291 17.0459 3.97473 18.1493 4.92984 19.0718C5.8523 20.0269 6.95575 20.7887 8.17579 21.3128C9.39583 21.8369 10.708 22.1128 12.0358 22.1243C13.3636 22.1358 14.6804 21.8828 15.9094 21.38C17.1383 20.8772 18.2549 20.1347 19.1938 19.1957C20.1327 18.2568 20.8752 17.1403 21.3781 15.9113C21.8809 14.6824 22.1339 13.3656 22.1223 12.0378C22.1108 10.71 21.8349 9.39778 21.3109 8.17774C20.7868 6.9577 20.0249 5.85426 19.0698 4.93179ZM17.6598 17.6618C16.3519 18.9712 14.6304 19.7866 12.7886 19.9691C10.9469 20.1516 9.09884 19.6898 7.55936 18.6626C6.01987 17.6353 4.88419 16.106 4.34581 14.3353C3.80742 12.5645 3.89964 10.6619 4.60675 8.95157C5.31386 7.24122 6.59211 5.82894 8.22373 4.95535C9.85534 4.08176 11.7394 3.80092 13.5548 4.16066C15.3703 4.5204 17.0049 5.49848 18.1801 6.92825C19.3553 8.35802 19.9984 10.151 19.9998 12.0018C20.0034 13.0531 19.7984 14.0946 19.3968 15.0662C18.9951 16.0377 18.4047 16.9199 17.6598 17.6618Z'
                fill='var(--alternative-text-color)'
              />
            </svg>
          </div>
          <div className='vault-commodities-modal-form'>
            <div className='vault-form-entity'>
              <div className='vault-form-row'>
                <div className='vault-form-combo'>
                  <p className='vault-form-label'>Commodity</p>
                  <Field
                    className='vault-form-input'
                    value={name}
                    onChange={(e: any) => setName(e.target.value)}
                  ></Field>
                </div>
                <div className='vault-form-combo'>
                  <p className='vault-form-label'>HS Code</p>
                  <Field
                    className='vault-form-input'
                    value={code}
                    onChange={(e: any) => setCode(e.target.value)}
                  ></Field>
                </div>
              </div>
              <div className='vault-form-row'>
                <div className='vault-form-combo'>
                  <p className='vault-form-label'>
                    Country of Residence/Origin
                  </p>
                  <Field
                    className='vault-form-input'
                    as='select'
                    value={origin}
                    onChange={(e: any) => setOrigin(e.target.value)}
                  >
                    {countryCodes.map((country, i) => {
                      return (
                        <option key={i} value={country.value}>
                          {country.label}
                        </option>
                      );
                    })}
                  </Field>
                </div>
                <div className='vault-form-combo'>
                  <p className='vault-form-label'>Trans Shipment Country</p>
                  <Field
                    className='vault-form-input'
                    as='select'
                    value={trans}
                    onChange={(e: any) => setTrans(e.target.value)}
                  >
                    {countryCodes.map((country, i) => {
                      return (
                        <option key={i} value={country.value}>
                          {country.label}
                        </option>
                      );
                    })}
                  </Field>
                </div>
              </div>
              <div className='vault-form-row'>
                <div className='vault-form-combo'>
                  <p className='vault-form-label'>Country of Destination</p>
                  <Field
                    className='vault-form-input'
                    as='select'
                    value={dest}
                    onChange={(e: any) => setDest(e.target.value)}
                  >
                    {countryCodes.map((country, i) => {
                      return (
                        <option key={i} value={country.value}>
                          {country.label}
                        </option>
                      );
                    })}
                  </Field>
                </div>
                <div className='vault-form-combo'></div>
              </div>
            </div>
          </div>
          <div className='vault-commodities-modal-btns'>
            <BackButton
              onClick={() => {
                handleModalClose();
              }}
            >
              Cancel
            </BackButton>
            <NextButton
              onClick={() => {
                handleAddCommodity();
                handleModalClose();
              }}
            >
              Add Entry
            </NextButton>
          </div>
        </div>
      </Modal>
    </div>
  );
};

export default CommodityForm;
